<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin"></div>
    </Transition>

    <v-form :name="formProps.formName"
            @keyup.enter="autoSave = false">
        <TabView scrollable
                 style="overflow: visible"
                 :pt="{ panelContainer: { class: 'form-tab-panel' } }">
            <TabPanel :header="__('Basic data')"
                      headerClass="form-tab-header">
                <div class="grid">
                    <FormDropdown fieldName="type"
                                  label="Criteria type"
                                  size="2"
                                  scrollHeight="200px"
                                  class="w-full"
                                  validation="required"
                                  :filtering="false"
                                  :isFormDisabled="isFormDisabled"
                                  :options="select?.assessments_types"
                                  v-model:field="crud.type" />

                    <FormInputText fieldName="label"
                                   label="Assessment label"
                                   size="4"
                                   validation="required"
                                   :isFormDisabled="isFormDisabled"
                                   :isFocus="true"
                                   v-model:field="crud.label" />

                    <FormInputNumber fieldName="value"
                                     label="Assessment value"
                                     size="2"
                                     :useGrouping="false"
                                     :min="0"
                                     :max="100"
                                     :minFractionDigits="0"
                                     :maxFractionDigits="0"
                                     :isFormDisabled="isFormDisabled"
                                     v-model:field="crud.value" />

                    <FormInputToggleButton fieldName="is_justification_required"
                                           label="Is justification required?"
                                           size="2"
                                           :isFormDisabled="isFormDisabled"
                                           v-model:field="crud.is_justification_required" />

                    <FormCalendar fieldName="valid_from"
                                  label="Valid from"
                                  size="2"
                                  :isFormDisabled="isFormDisabled"
                                  v-model:field="crud.valid_from" />

                    <FormCalendar fieldName="valid_to"
                                  label="Valid to"
                                  size="2"
                                  :isFormDisabled="isFormDisabled"
                                  v-model:field="crud.valid_to" />
                </div>
                <div class="grid">
                    <FormEditor fieldName="description"
                                label="Description"
                                :editorStyle="{ height: '120px' }"
                                :isFormDisabled="isFormDisabled"
                                v-model:field="crud.description" />
                </div>
            </TabPanel>

            <TabPanel v-if="crud.log"
                      :header="__('Changelog')"
                      headerClass="form-tab-header">
                <ChangeLog :log="crud?.log" />
            </TabPanel>

        </TabView>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled"
                         v-model:autoSave="autoSave">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import { validation, initForm } from '@pages/Helper/crud_utils.js'
import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormInputToggleButton from '@crud/FormInputToggleButton.vue'
import FormDropdown from '@crud/FormDropdown.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(false)
const autoSave = ref(false)

const options = ['assessments_types']
const select = ref(null)
const crud = ref({})
const buttonsVisibility = ref(null);

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, options, select, buttonsVisibility)
})

// -----------------------------------------------------


</script>

<style lang="scss" scoped></style>
